import React, { useState } from "react";
import css from "./form.module.css";
import { FiSend } from "react-icons/fi";

const projectTypes = [
  "Full-stack developer role",
  "Mobile developer role",
  "AI integration role",
  "Freelance project",
  "Contract collaboration",
  "Other",
];

const ContactForm = () => {
  const [name, setName] = useState("");
  const [projectType, setProjectType] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required";
    if (!projectType) newErrors.projectType = "Select a topic";
    if (!message.trim()) newErrors.message = "Add a short message";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const text = `Hi Abdellah, I'm ${name.trim()}.\n\nI'm reaching out about: ${projectType}\n\n${message.trim()}`;
    const encoded = encodeURIComponent(text);
    window.open(`https://wa.me/393522947771?text=${encoded}`, "_blank");
  };

  return (
    <form onSubmit={handleSubmit} noValidate className={css.form}>
      <div className={css.formgroup}>
        <label className={css.label}>Your Name</label>
        <input
          type="text"
          className={css.input}
          placeholder="Ibrahim Ali"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (errors.name) setErrors((p) => ({ ...p, name: "" }));
          }}
          aria-invalid={!!errors.name}
        />
        {errors.name && <span className={css.error}>{errors.name}</span>}
      </div>

      <div className={css.formgroup}>
        <label className={css.label}>Opportunity type</label>
        <select
          className={css.select}
          value={projectType}
          onChange={(e) => {
            setProjectType(e.target.value);
            if (errors.projectType) setErrors((p) => ({ ...p, projectType: "" }));
          }}
          aria-invalid={!!errors.projectType}
        >
          <option value="" disabled>
            Select the best match
          </option>
          {projectTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
        {errors.projectType && (
          <span className={css.error}>{errors.projectType}</span>
        )}
      </div>

      <div className={css.formgroup}>
        <label className={css.label}>Message</label>
        <textarea
          className={css.textarea}
          placeholder="Tell me about the role, team, product, and what success looks like..."
          rows="5"
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
            if (errors.message) setErrors((p) => ({ ...p, message: "" }));
          }}
          aria-invalid={!!errors.message}
        />
        {errors.message && <span className={css.error}>{errors.message}</span>}
      </div>

      <button type="submit" className={css.submitBtn}>
        <FiSend />
        <span>Start the conversation</span>
      </button>
    </form>
  );
};

export default ContactForm;
